class ProductCrossesDescriptionCtrl {
  static bindings = {
    product: '<',
    isVoteCountVisible: '<'
  };

  isVoteCountVisible =  true;
  product;
}

export const ProductCrossesDescriptionComponent = {
  template: require('./productCrossesDescription.component.html'),
  controller: ProductCrossesDescriptionCtrl,
  transclude: true,
  bindings: ProductCrossesDescriptionCtrl.bindings
};
